/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CostsRouteImport } from './routes/costs'
import { Route as LabelsRouteImport } from './routes/labels'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as ToOrderRouteImport } from './routes/to-order'
import { Route as InventoryIndexRouteImport } from './routes/inventory/index'
import { Route as InventoryPartIdRouteImport } from './routes/inventory/$partId'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as OrdersOrderIdRouteImport } from './routes/orders/$orderId'
import { Route as QrIndexRouteImport } from './routes/qr/index'
import { Route as QrCodeRouteImport } from './routes/qr/$code'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsAboutRouteImport } from './routes/settings/about'
import { Route as SettingsAppearanceRouteImport } from './routes/settings/appearance'
import { Route as SettingsChassisCodesRouteImport } from './routes/settings/chassis-codes'
import { Route as SettingsDataRouteImport } from './routes/settings/data'
import { Route as SettingsGarageRouteImport } from './routes/settings/garage'
import { Route as SettingsInstallationRouteImport } from './routes/settings/installation'
import { Route as SettingsLocationsRouteImport } from './routes/settings/locations'
import { Route as SettingsMembersRouteImport } from './routes/settings/members'
import { Route as SettingsModulesRouteImport } from './routes/settings/modules'
import { Route as SettingsPackagesRouteImport } from './routes/settings/packages'
import { Route as SettingsPricesRouteImport } from './routes/settings/prices'
import { Route as SettingsRoadworthinessRouteImport } from './routes/settings/roadworthiness'
import { Route as SettingsSuppliersRouteImport } from './routes/settings/suppliers'
import { Route as SettingsTagsRouteImport } from './routes/settings/tags'
import { Route as SettingsUsersRouteImport } from './routes/settings/users'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as TemplatesTemplateIdRouteImport } from './routes/templates/$templateId'
import { Route as VehiclesIndexRouteImport } from './routes/vehicles/index'
import { Route as VehiclesVehicleIdRouteImport } from './routes/vehicles/$vehicleId'
import { Route as WorkOrdersIndexRouteImport } from './routes/work-orders/index'
import { Route as WorkOrdersWorkOrderIdRouteImport } from './routes/work-orders/$workOrderId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CostsRoute = CostsRouteImport.update({
  id: '/costs',
  path: '/costs',
  getParentRoute: () => rootRouteImport,
} as any)
const LabelsRoute = LabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ToOrderRoute = ToOrderRouteImport.update({
  id: '/to-order',
  path: '/to-order',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryIndexRoute = InventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryPartIdRoute = InventoryPartIdRouteImport.update({
  id: '/inventory/$partId',
  path: '/inventory/$partId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const QrIndexRoute = QrIndexRouteImport.update({
  id: '/qr/',
  path: '/qr/',
  getParentRoute: () => rootRouteImport,
} as any)
const QrCodeRoute = QrCodeRouteImport.update({
  id: '/qr/$code',
  path: '/qr/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAboutRoute = SettingsAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsChassisCodesRoute = SettingsChassisCodesRouteImport.update({
  id: '/chassis-codes',
  path: '/chassis-codes',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsDataRoute = SettingsDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsGarageRoute = SettingsGarageRouteImport.update({
  id: '/garage',
  path: '/garage',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsInstallationRoute = SettingsInstallationRouteImport.update({
  id: '/installation',
  path: '/installation',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsLocationsRoute = SettingsLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsMembersRoute = SettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsModulesRoute = SettingsModulesRouteImport.update({
  id: '/modules',
  path: '/modules',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsPackagesRoute = SettingsPackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsPricesRoute = SettingsPricesRouteImport.update({
  id: '/prices',
  path: '/prices',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsRoadworthinessRoute = SettingsRoadworthinessRouteImport.update({
  id: '/roadworthiness',
  path: '/roadworthiness',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsSuppliersRoute = SettingsSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsTagsRoute = SettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesTemplateIdRoute = TemplatesTemplateIdRouteImport.update({
  id: '/templates/$templateId',
  path: '/templates/$templateId',
  getParentRoute: () => rootRouteImport,
} as any)
const VehiclesIndexRoute = VehiclesIndexRouteImport.update({
  id: '/vehicles/',
  path: '/vehicles/',
  getParentRoute: () => rootRouteImport,
} as any)
const VehiclesVehicleIdRoute = VehiclesVehicleIdRouteImport.update({
  id: '/vehicles/$vehicleId',
  path: '/vehicles/$vehicleId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkOrdersIndexRoute = WorkOrdersIndexRouteImport.update({
  id: '/work-orders/',
  path: '/work-orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkOrdersWorkOrderIdRoute = WorkOrdersWorkOrderIdRouteImport.update({
  id: '/work-orders/$workOrderId',
  path: '/work-orders/$workOrderId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/costs': typeof CostsRoute
  '/labels': typeof LabelsRoute
  '/to-order': typeof ToOrderRoute
  '/inventory/$partId': typeof InventoryPartIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/qr/$code': typeof QrCodeRoute
  '/settings/about': typeof SettingsAboutRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/chassis-codes': typeof SettingsChassisCodesRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/garage': typeof SettingsGarageRoute
  '/settings/installation': typeof SettingsInstallationRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/modules': typeof SettingsModulesRoute
  '/settings/packages': typeof SettingsPackagesRoute
  '/settings/prices': typeof SettingsPricesRoute
  '/settings/roadworthiness': typeof SettingsRoadworthinessRoute
  '/settings/suppliers': typeof SettingsSuppliersRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/vehicles/$vehicleId': typeof VehiclesVehicleIdRoute
  '/work-orders/$workOrderId': typeof WorkOrdersWorkOrderIdRoute
  '/inventory/': typeof InventoryIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/qr/': typeof QrIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/vehicles/': typeof VehiclesIndexRoute
  '/work-orders/': typeof WorkOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/costs': typeof CostsRoute
  '/labels': typeof LabelsRoute
  '/to-order': typeof ToOrderRoute
  '/inventory/$partId': typeof InventoryPartIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/qr/$code': typeof QrCodeRoute
  '/settings/about': typeof SettingsAboutRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/chassis-codes': typeof SettingsChassisCodesRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/garage': typeof SettingsGarageRoute
  '/settings/installation': typeof SettingsInstallationRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/modules': typeof SettingsModulesRoute
  '/settings/packages': typeof SettingsPackagesRoute
  '/settings/prices': typeof SettingsPricesRoute
  '/settings/roadworthiness': typeof SettingsRoadworthinessRoute
  '/settings/suppliers': typeof SettingsSuppliersRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/vehicles/$vehicleId': typeof VehiclesVehicleIdRoute
  '/work-orders/$workOrderId': typeof WorkOrdersWorkOrderIdRoute
  '/inventory': typeof InventoryIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/qr': typeof QrIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/vehicles': typeof VehiclesIndexRoute
  '/work-orders': typeof WorkOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/costs': typeof CostsRoute
  '/labels': typeof LabelsRoute
  '/to-order': typeof ToOrderRoute
  '/inventory/$partId': typeof InventoryPartIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/qr/$code': typeof QrCodeRoute
  '/settings/about': typeof SettingsAboutRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/chassis-codes': typeof SettingsChassisCodesRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/garage': typeof SettingsGarageRoute
  '/settings/installation': typeof SettingsInstallationRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/modules': typeof SettingsModulesRoute
  '/settings/packages': typeof SettingsPackagesRoute
  '/settings/prices': typeof SettingsPricesRoute
  '/settings/roadworthiness': typeof SettingsRoadworthinessRoute
  '/settings/suppliers': typeof SettingsSuppliersRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/vehicles/$vehicleId': typeof VehiclesVehicleIdRoute
  '/work-orders/$workOrderId': typeof WorkOrdersWorkOrderIdRoute
  '/inventory/': typeof InventoryIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/qr/': typeof QrIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/vehicles/': typeof VehiclesIndexRoute
  '/work-orders/': typeof WorkOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/costs'
    | '/labels'
    | '/to-order'
    | '/inventory/$partId'
    | '/orders/$orderId'
    | '/qr/$code'
    | '/settings/about'
    | '/settings/appearance'
    | '/settings/chassis-codes'
    | '/settings/data'
    | '/settings/garage'
    | '/settings/installation'
    | '/settings/locations'
    | '/settings/members'
    | '/settings/modules'
    | '/settings/packages'
    | '/settings/prices'
    | '/settings/roadworthiness'
    | '/settings/suppliers'
    | '/settings/tags'
    | '/settings/users'
    | '/templates/$templateId'
    | '/vehicles/$vehicleId'
    | '/work-orders/$workOrderId'
    | '/inventory/'
    | '/orders/'
    | '/qr/'
    | '/settings/'
    | '/templates/'
    | '/vehicles/'
    | '/work-orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/costs'
    | '/labels'
    | '/to-order'
    | '/inventory/$partId'
    | '/orders/$orderId'
    | '/qr/$code'
    | '/settings/about'
    | '/settings/appearance'
    | '/settings/chassis-codes'
    | '/settings/data'
    | '/settings/garage'
    | '/settings/installation'
    | '/settings/locations'
    | '/settings/members'
    | '/settings/modules'
    | '/settings/packages'
    | '/settings/prices'
    | '/settings/roadworthiness'
    | '/settings/suppliers'
    | '/settings/tags'
    | '/settings/users'
    | '/templates/$templateId'
    | '/vehicles/$vehicleId'
    | '/work-orders/$workOrderId'
    | '/inventory'
    | '/orders'
    | '/qr'
    | '/settings'
    | '/templates'
    | '/vehicles'
    | '/work-orders'
  id:
    | '__root__'
    | '/'
    | '/settings'
    | '/costs'
    | '/labels'
    | '/to-order'
    | '/inventory/$partId'
    | '/orders/$orderId'
    | '/qr/$code'
    | '/settings/about'
    | '/settings/appearance'
    | '/settings/chassis-codes'
    | '/settings/data'
    | '/settings/garage'
    | '/settings/installation'
    | '/settings/locations'
    | '/settings/members'
    | '/settings/modules'
    | '/settings/packages'
    | '/settings/prices'
    | '/settings/roadworthiness'
    | '/settings/suppliers'
    | '/settings/tags'
    | '/settings/users'
    | '/templates/$templateId'
    | '/vehicles/$vehicleId'
    | '/work-orders/$workOrderId'
    | '/inventory/'
    | '/orders/'
    | '/qr/'
    | '/settings/'
    | '/templates/'
    | '/vehicles/'
    | '/work-orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  CostsRoute: typeof CostsRoute
  LabelsRoute: typeof LabelsRoute
  ToOrderRoute: typeof ToOrderRoute
  InventoryPartIdRoute: typeof InventoryPartIdRoute
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
  QrCodeRoute: typeof QrCodeRoute
  TemplatesTemplateIdRoute: typeof TemplatesTemplateIdRoute
  VehiclesVehicleIdRoute: typeof VehiclesVehicleIdRoute
  WorkOrdersWorkOrderIdRoute: typeof WorkOrdersWorkOrderIdRoute
  InventoryIndexRoute: typeof InventoryIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  QrIndexRoute: typeof QrIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
  VehiclesIndexRoute: typeof VehiclesIndexRoute
  WorkOrdersIndexRoute: typeof WorkOrdersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/costs': {
      id: '/costs'
      path: '/costs'
      fullPath: '/costs'
      preLoaderRoute: typeof CostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/labels': {
      id: '/labels'
      path: '/labels'
      fullPath: '/labels'
      preLoaderRoute: typeof LabelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/to-order': {
      id: '/to-order'
      path: '/to-order'
      fullPath: '/to-order'
      preLoaderRoute: typeof ToOrderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/': {
      id: '/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof InventoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/$partId': {
      id: '/inventory/$partId'
      path: '/inventory/$partId'
      fullPath: '/inventory/$partId'
      preLoaderRoute: typeof InventoryPartIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qr/': {
      id: '/qr/'
      path: '/qr'
      fullPath: '/qr/'
      preLoaderRoute: typeof QrIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qr/$code': {
      id: '/qr/$code'
      path: '/qr/$code'
      fullPath: '/qr/$code'
      preLoaderRoute: typeof QrCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/about': {
      id: '/settings/about'
      path: '/about'
      fullPath: '/settings/about'
      preLoaderRoute: typeof SettingsAboutRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/chassis-codes': {
      id: '/settings/chassis-codes'
      path: '/chassis-codes'
      fullPath: '/settings/chassis-codes'
      preLoaderRoute: typeof SettingsChassisCodesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/data': {
      id: '/settings/data'
      path: '/data'
      fullPath: '/settings/data'
      preLoaderRoute: typeof SettingsDataRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/garage': {
      id: '/settings/garage'
      path: '/garage'
      fullPath: '/settings/garage'
      preLoaderRoute: typeof SettingsGarageRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/installation': {
      id: '/settings/installation'
      path: '/installation'
      fullPath: '/settings/installation'
      preLoaderRoute: typeof SettingsInstallationRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/locations': {
      id: '/settings/locations'
      path: '/locations'
      fullPath: '/settings/locations'
      preLoaderRoute: typeof SettingsLocationsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/members': {
      id: '/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof SettingsMembersRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/modules': {
      id: '/settings/modules'
      path: '/modules'
      fullPath: '/settings/modules'
      preLoaderRoute: typeof SettingsModulesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/packages': {
      id: '/settings/packages'
      path: '/packages'
      fullPath: '/settings/packages'
      preLoaderRoute: typeof SettingsPackagesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/prices': {
      id: '/settings/prices'
      path: '/prices'
      fullPath: '/settings/prices'
      preLoaderRoute: typeof SettingsPricesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/roadworthiness': {
      id: '/settings/roadworthiness'
      path: '/roadworthiness'
      fullPath: '/settings/roadworthiness'
      preLoaderRoute: typeof SettingsRoadworthinessRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/suppliers': {
      id: '/settings/suppliers'
      path: '/suppliers'
      fullPath: '/settings/suppliers'
      preLoaderRoute: typeof SettingsSuppliersRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/tags': {
      id: '/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof SettingsTagsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/$templateId': {
      id: '/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof TemplatesTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicles/': {
      id: '/vehicles/'
      path: '/vehicles'
      fullPath: '/vehicles/'
      preLoaderRoute: typeof VehiclesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicles/$vehicleId': {
      id: '/vehicles/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/vehicles/$vehicleId'
      preLoaderRoute: typeof VehiclesVehicleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/': {
      id: '/work-orders/'
      path: '/work-orders'
      fullPath: '/work-orders/'
      preLoaderRoute: typeof WorkOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders/$workOrderId': {
      id: '/work-orders/$workOrderId'
      path: '/work-orders/$workOrderId'
      fullPath: '/work-orders/$workOrderId'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteRouteChildren {
  SettingsAboutRoute: typeof SettingsAboutRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsChassisCodesRoute: typeof SettingsChassisCodesRoute
  SettingsDataRoute: typeof SettingsDataRoute
  SettingsGarageRoute: typeof SettingsGarageRoute
  SettingsInstallationRoute: typeof SettingsInstallationRoute
  SettingsLocationsRoute: typeof SettingsLocationsRoute
  SettingsMembersRoute: typeof SettingsMembersRoute
  SettingsModulesRoute: typeof SettingsModulesRoute
  SettingsPackagesRoute: typeof SettingsPackagesRoute
  SettingsPricesRoute: typeof SettingsPricesRoute
  SettingsRoadworthinessRoute: typeof SettingsRoadworthinessRoute
  SettingsSuppliersRoute: typeof SettingsSuppliersRoute
  SettingsTagsRoute: typeof SettingsTagsRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsAboutRoute: SettingsAboutRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsChassisCodesRoute: SettingsChassisCodesRoute,
  SettingsDataRoute: SettingsDataRoute,
  SettingsGarageRoute: SettingsGarageRoute,
  SettingsInstallationRoute: SettingsInstallationRoute,
  SettingsLocationsRoute: SettingsLocationsRoute,
  SettingsMembersRoute: SettingsMembersRoute,
  SettingsModulesRoute: SettingsModulesRoute,
  SettingsPackagesRoute: SettingsPackagesRoute,
  SettingsPricesRoute: SettingsPricesRoute,
  SettingsRoadworthinessRoute: SettingsRoadworthinessRoute,
  SettingsSuppliersRoute: SettingsSuppliersRoute,
  SettingsTagsRoute: SettingsTagsRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  CostsRoute: CostsRoute,
  LabelsRoute: LabelsRoute,
  ToOrderRoute: ToOrderRoute,
  InventoryPartIdRoute: InventoryPartIdRoute,
  OrdersOrderIdRoute: OrdersOrderIdRoute,
  QrCodeRoute: QrCodeRoute,
  TemplatesTemplateIdRoute: TemplatesTemplateIdRoute,
  VehiclesVehicleIdRoute: VehiclesVehicleIdRoute,
  WorkOrdersWorkOrderIdRoute: WorkOrdersWorkOrderIdRoute,
  InventoryIndexRoute: InventoryIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  QrIndexRoute: QrIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
  VehiclesIndexRoute: VehiclesIndexRoute,
  WorkOrdersIndexRoute: WorkOrdersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
